// extracted by mini-css-extract-plugin
export default {"Skill":"skill_Skill__-07pX"};